import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FoundationModule } from '@fundament/foundation/foundation.module';
import { LoadingAppComponent } from './loading-app.component';

@NgModule({
  imports: [FoundationModule, CommonModule],
  declarations: [LoadingAppComponent],
  exports: [LoadingAppComponent],
})
export class LoadingAppModule {}
